export default {
    namespaced: true,
    state: () => ({
      title: '',
      content: '',
      show: false
    }),
    mutations: {
      showMessage(state, { title, content }) {
        state.title = title
        state.content = content
        state.show = true
      },
      hideMessage(state) {
        state.show = false
        state.title = ''
        state.content = ''
      }
    },
    getters: {
      messageTitle: state => state.title,
      messageContent: state => state.content,
      isVisible: state => state.show
    }
  }